import {Component} from '@angular/core';
import {SubformArray} from '../../subform-array';

@Component({
    selector: 'specialist-form-fields-permits',
    template: `
        <div *ngFor="let group of fbArray.controls" class="highlight-container">
            <app-permit-subform [form]="group"></app-permit-subform>
        </div>
        <button class="button-transparent" type="button" (click)="addGroup()">
            <lib-icon type="card" [size]="12"></lib-icon> Добавить сведения о допусках или разрешениях
        </button>
    `
})

export class SpecialistFormFieldsPermitsComponent extends SubformArray {

}
